<div class="modal-body">
  <div class="modal-header-wrapper">
    <h2 class="title-text">Impression du journal</h2>
    <p class="subtitle-text">Choisir les options d'impression du journal</p>
  </div>
  <div id="modal-content-wrapper">
    <div class="form-check">
      <input class="form-check-input"
             [(ngModel)]="withEncouragements"
             id="with-encouragements-checkbox"
             type="checkbox">
      <label class="form-check-label call-to-action-md" for="with-encouragements-checkbox">
        Imprimer les encouragements
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input"
             [(ngModel)]="withImages"
             id="with-images-checkbox"
             type="checkbox">
      <label class="form-check-label call-to-action-md" for="with-images-checkbox">
        Imprimer les photos ou images
      </label>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="hideModal()" type="button"
          class="btn btn-outline-primary btn-outline text-only">
    Annuler
  </button>

  <button (click)="validate()" class="btn btn-primary btn-gradient">
      Imprimer
  </button>
</div>
